import lang from 'dojo/_base/lang';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './emailHome.html?raw';
import RequestManager from 'more/RequestManager';

import "./EmailFinder";
import "./emailForm";
import EmailFinder from './EmailFinder';
import emailForm from './emailForm';
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import "./emailSuggestion/emailSuggestion";
import { EmailEditorTypes } from "./emailTypes";
import { _TabEnabledMixin } from "../../moreCore/_loadingHelpers/Tabbing";


class emailHome extends compose(_TabEnabledMixin) {
    reqMgr: RequestManager;

    templateString: any = template;
    mailFormPlaceHolder: MdsLax<InstanceType<typeof emailForm>>;
    mailSelect: MdsLax<InstanceType<typeof EmailFinder>>;
    mailFormEntry: HTMLDivElement;
    //mailForm: Array<emailForm> = [];
    mailWarningsAndInfoContainer: HTMLDivElement;

    displayMailList: Array<EmailEditorTypes.savedMail> = [];
    displayMailData: Record<string, MdsLax<InstanceType<typeof emailForm>>> = {};

    mailListReloadInterval: number = 600000; //=10min

    mainContainer:HTMLDivElement;

    // updateMailListDeleteEntry()
    flagCurrentEntryUpForDeletion: string;

    //#region postCreate
    postCreate(): void {
        //#######################
        // pre-loads die Maillist, auch wenn diese am Anfang noch nicht sichtbar ist
        // setzt event handler fuer emailPicker
        this.mailSelect.on("entry-select", lang.hitch(this, (ev: any) => { 
            this.updateMailForm(((ev as any) as EmailEditorTypes.savedMail).ID);
        }));
        this.mailSelect.on("enty-delete", (ev: any) => { this.updateMailListDeleteEntry((ev as EmailEditorTypes.MailFormData).ID);});
        this.mailSelect.on("createNewMail", lang.hitch(this, this.newMailField));
        //setInterval(this.updateMailList.bind(this), this.mailListReloadInterval);
        setTimeout(lang.hitch(this, ()=>{
            this.requestTabSwitchGlobal("emailPicker");
            //workaround, um sicherzustellen das der mail picker immer sichtbar ist
        }), 50);
    }

    private newMailField() {
        let newID = String(new Date().valueOf()) + "_" + "NEW";
        let mailEditor = new emailForm(); // added den record
        mailEditor.startup();
        this.displayMailData[newID] = mailEditor;
        //this.displayMailData[newID].flagIsEmptyNewMail = true;
        this.openNewFormTab(newID);
        
    }

    //#region new tab
    private openNewFormTab(entryID: string) {
        let newName = "MAIL_DATA_" + entryID;
        this.createNewTabbedContent({
            name: newName,
            label: "E-Mail Editor",
            widget: this.displayMailData[entryID],
            enableClosing: true,
            targetContainerName: this.mailSelect.getTabContainerName(),
        }, true, true);
        //this.displayMailData[entryID].setTabID(entryID);
        //this.displayMailData[entryID].setTabName(newName);
        this.displayMailData[entryID].on("tabClosed", lang.hitch(this, (key) => {
            //#region tab closed
            let targetKey = key.split("MAIL_DATA_")[1]; // holt sich den array key aus dem tabContainer key raus MAIL_DATA_<key>
            this.displayMailData[targetKey].destroy();
            delete this.displayMailData[targetKey];
        }));
        this.displayMailData[entryID].on("openNewFormTab", lang.hitch(this, this.openNewFormTab));
        this.displayMailData[entryID].on("updateMailForm", lang.hitch(this, (newID)=>{
            this.updateMailForm(newID);
            
        }));
    }


    //#region rm entry
    private async updateMailListDeleteEntry(id: string) { //id ist mailData.id
        this.flagCurrentEntryUpForDeletion = id;
        // triggered wenn der Delete Button im MailPicker ausgewaehlt wird
        let dlg = new GenericDialog();
        dlg.destroyOnClose = true;
        dlg.setSize("smaller");
        dlg.closeOnEnter = false;
        dlg.closeOnEscape = false;
        dlg._setTopCloseBtnAttr(false);
        this.flagCurrentEntryUpForDeletion = id;
        if (document.activeElement != document.body) {
            //entfernt den focus vom geclickten button, da man ansonsten neue popups spamen könnte
            try {
                //@ts-expect-error
                document.activeElement.blur();
            } catch {/*elemnt hat kein blur()*/ }
        }
        dlg.show(window.translations["email_mailPicker_popup_Body_part1"] + ' <br> ' + window.translations["email_mailPicker_popup_Body_part2"],
            window.translations["email_mailPicker_popup_Header"], null, "far fa-trash-alt w3-xxlarge",
            'yesno', lang.hitch(this, this._onDlgCallback, id));

        dlg.placeAt(this.mailWarningsAndInfoContainer);
    }

    //#region update form
    private async updateMailForm(entryID: string) {
        for (let key in this.displayMailData) {
            if (String(entryID) == (key.substring(key.indexOf("_") + 1, key.length))) {
                this.requestTabSwitchGlobal("MAIL_DATA_" + key);
                return; // wenn der tab bereits existiert, dann switch darauf, statt neu zu erstellen
            }
        }
        // wenn der tab nicht existiert, werden die Daten von der API gefetcht und als neuer tab dargestellt
        let newID = String(new Date().valueOf()) + "_" + entryID;
        this.displayMailData[newID] = new emailForm(); // added den record
        this.openNewFormTab(newID);
    }

    //#region API calls func

    public APIfetchMailListDeleteEntry(id: string) { //loescht eine ausgewaehlte mail form
        let apiURL = window.appRoot + "EMail/MailListRemoveEntry";
        return new Promise((resolve, reject) => {
            this.reqMgr.post(apiURL, { id: id },
                (response) => {
                    resolve(true);
                },
                (error) => {
                    reject(false);
                }
            );
        });
    }

    private async _onDlgCallback(id: string, result: number) {
    //let id = this.flagCurrentEntryUpForDeletion;
    if (result === 2) { // yes button wurde geclickt
       
    }
}

    //----------------------------------------------------------------------------------------------------------

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

}

mdsLazyProto(emailHome.prototype, {
  reqMgr: () => (new RequestManager()),
});
export default mdsWidget(emailHome);
